import { api } from "./configs/axiosConfigs"

export const ListOfProductsAPI = {
    
    getListOfProducts: async () => {
        const response = await api.get(
            '/listProducts',
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createListOfProduct: async (data: any) => {
        const response = await api.post(
            '/listProducts/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editListOfProduct: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/listProducts/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteListOfProduct: async (idlist: number) => {
        const response = await api.delete(
            `/listProducts/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}